export default defineNuxtRouteMiddleware(async to => {
  // If this is an async request for one of the assets in the _nuxt dir, skip
  if (to.path.startsWith('/_nuxt/')) {
    return;
  }

  // If this is the login page, just skip
  if (to.meta.isLoginPage) {
    return;
  }

  // Redirect to the authenticated dashboard page if route doesn't match
  if (to.matched.length === 0) {
    return navigateTo('/');
  }

  if (to.meta.appName || to.meta.isAppPage) {
    // Check to make sure the user is authorized to view this app
    const appSlug = (to.meta.appName || to.meta.slug || to.matched[0].name) as string;
    const apps = useApps();
    await apps.fetch();

    if (apps.all.length === 0) {
      // If no apps exist, either something is wrong or the user's server token expired
      const next = to.query.next as string | undefined;
      return navigateTo(`/error?next=${next}`);
    }
    // If there's no app with a matching slug, redirect to the dashboard page
    if (!apps.bySlug[appSlug]) {
      return navigateTo('/');
    }

    apps.setCurrent(appSlug);
  }
});
